import { checkoutShippingOrderNotesEntryStyles } from "@insite/content-library/Widgets/CheckoutShipping/CheckoutShippingOrderNotesEntry";
import { css } from "styled-components";

/**** EC-564-[FE] Code injection ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
checkoutShippingOrderNotesEntryStyles.textArea = {
   
    labelProps:{
        size: 15,
        weight: 600,
        css: css`
            margin-top: 25px;
        `,
    },
    css: css`
        min-width: 100%;
        max-width: 100%;
        min-height: 50px;
        margin-bottom: 25px;
        
    `,
};

/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
